export function Tag({ tone = "zinc", isDarkMode, children }) {
  const tones = {
    zinc: isDarkMode ? "bg-gray-800 text-gray-200 border-gray-700" : "bg-gray-100 text-gray-700 border-gray-200",
    emerald: "bg-emerald-600/15 text-emerald-300 border-emerald-500/30",
    amber: "bg-amber-600/15 text-amber-300 border-amber-500/30",
    sky: "bg-sky-600/15 text-sky-300 border-sky-500/30",
    rose: "bg-rose-600/15 text-rose-300 border-rose-500/30",
    blue: "bg-blue-600/15 text-blue-300 border-blue-500/30",
  };

  return (
    <span className={`inline-flex items-center rounded-lg border px-2 py-1 text-[10px] ${tones[tone] || tones.zinc}`}>
      {children}
    </span>
  );
}
